module.exports = __webpack_public_path__ + "img/mobile-menu-panel-bg.68f5a681.jpg";